/**
 * CTASection Component
 * Landing page call-to-action footer section
 */

import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export const CTASection = () => {
  return (
    <section className="py-20 px-6">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center p-12 rounded-3xl glass relative overflow-hidden">
          <div className="absolute inset-0 gradient-animate opacity-30"></div>
          <div className="relative z-10">
            <Sparkles className="mx-auto text-primary mb-4" size={48} />
            <h2 className="text-4xl font-bold text-primary mb-4">
              Ready to Transform Your Store?
            </h2>
            <p className="text-foreground/80 mb-8 max-w-xl mx-auto">
              Join thousands of e-commerce brands already using MerchMidas to
              create stunning product visuals.
            </p>
            <Button variant="hero" size="lg" asChild className="glow-hover">
              <Link to="/app">
                Get Started Free
                <ArrowRight className="ml-2" size={20} />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
